// This file stores components shared between the work area and sidebar
import { observable, action, makeAutoObservable  } from 'mobx'


class TextStyleToolbar {
  @observable id
  
  constructor(id) {
    makeAutoObservable(this);
    this.id = id
  }

}

class SelectBox {
  @observable height
  @observable width
  @observable xPos
  @observable yPos
  @observable layers
  
  constructor(width, height, xPos, yPos, layers){
    makeAutoObservable(this)
    this.width = width
    this.height = height
    this.layers = layers
    this.xPos = xPos
    this.yPos = yPos
  }
}

class LayerGroup {
  @observable id
  @observable height
  @observable width
  @observable displayHeight
  @observable displayWidth
  @observable originalDisplayWidth
  @observable originalDisplayHeight
  @observable frameWidth
  @observable frameHeight
  @observable yPos
  @observable xPos
  @observable xCrop
  @observable yCrop
  @observable scale
  @observable rotation
  @observable layers
  @observable selected
  @observable alignMap
  @observable locked
  @observable finalGroup

  constructor(
    id,
    height,
    width,
    displayHeight,
    displayWidth,
    originalDisplayHeight,
    originalDisplayWidth,
    frameWidth,
    frameHeight,
    xPos,
    yPos,
    xCrop,
    yCrop,
    scale,
    rotation,
    layers,
    finalGroup,
    locked,
    alignMap,
    selected
  ){
    makeAutoObservable(this)  
    this.type = 'group'
    this.id = id  
    this.height = height
    this.width = width
    this.displayHeight = displayHeight
    this.displayWidth = displayWidth
    this.yPos = yPos
    this.xPos = xPos
    this.scale = scale
    this.xCrop = xCrop
    this.yCrop = yCrop
    this.frameWidth = frameWidth
    this.frameHeight = frameHeight
    this.originalDisplayHeight = originalDisplayHeight
    this.originalDisplayWidth = originalDisplayWidth
    this.rotation = rotation
    this.layers = layers
    this.locked = locked
    this.alignMap = alignMap
    //If layer has finalgroup prop true then all the layers connected exist within the group
    this.finalGroup = finalGroup
    this.selected = selected
  }

}

class TextElement {
  @observable id
  @observable content
  @observable font
  @observable colors
  @observable weight
  @observable scale
  @observable rotation
  @observable height
  @observable width
  @observable frameHeight
  @observable frameWidth
  @observable displayHeight
  @observable xCrop
  @observable yCrop
  @observable xPos
  @observable yPos
  @observable displayWidth
  @observable originalDisplayWidth
  @observable originalDisplayHeight
  @observable selected
  @observable lineHeight
  @observable spacing
  @observable italic
  @observable underline
  @observable opacity
  @observable groupId
  @observable editorWidth
  @observable editorHeight
  @observable alignMap
  @observable editing
  @observable textAlign
  @observable extraStyle
  @observable textShadow
  @observable locked
  
  constructor(
    id, 
    content,
    textShadow, 
    size, 
    xPos, 
    yPos, 
    font, 
    colors, 
    weight, 
    scale, 
    rotation, 
    width, 
    height,
    displayHeight,
    displayWidth,
    originalDisplayHeight,
    originalDisplayWidth,
    frameHeight,
    frameWidth,
    xCrop,
    yCrop,
    lineHeight,
    spacing,
    opacity,
    italic,
    underline,
    groupId,
    editorHeight,
    editorWidth,
    editing,
    textAlign,
    locked,
    alignMap,
    selected,
    extraStyle
    ){
    makeAutoObservable(this);
    this.id = id
    this.type = 'text'
    this.content = content
    this.size = size
    this.xPos = xPos
    this.yPos = yPos
    this.font = font
    this.colors = colors
    this.weight = weight
    this.scale = scale
    this.rotation = rotation
    this.locked = locked
    this.width = width
    this.height = height
    this.displayHeight = displayHeight
    this.displayWidth = displayWidth
    this.frameHeight = frameHeight
    this.frameWidth = frameWidth
    this.originalDisplayHeight = originalDisplayHeight
    this.originalDisplayWidth = originalDisplayWidth
    this.xCrop = xCrop
    this.yCrop = yCrop
    this.lineHeight = lineHeight
    this.spacing = spacing
    this.opacity = opacity
    this.italic = italic
    this.underline = underline
    this.groupId = groupId
    this.editorHeight = editorHeight
    this.editorWidth = editorWidth
    this.alignMap = alignMap
    this.textAlign = textAlign
    this.textShadow = textShadow
    this.editing = editing
    this.selected = selected
    this.extraStyle = extraStyle
  }
}

class ContextMenu {

  @observable xPos
  @observable yPos
  @observable actions
  @observable display

  constructor(xPos, yPos, actions, display){
    makeAutoObservable(this)
    this.xPos = xPos
    this.yPos = yPos
    this.actions = actions
    this.display = display
  }

}

class TemplateItem {

  @observable id
  @observable selected
  @observable title
  @observable width
  @observable height
  @observable scale
  @observable background
  @observable icon
  @observable type
  @observable displayBackground


  constructor(id, title, icon, dataSource, width, height, scale, background, type, displayBackground, selected = false){
    makeAutoObservable(this);
    this.id = id
    this.selected = selected
    this.title = title
    this.dataSource = dataSource
    this.icon = icon
    this.foundItems = []
    this.width = width
    this.height = height
    this.scale = scale
    this.background = background
    this.displayBackground = displayBackground
    this.type = type
  }
}

class PhotoElement {

  @observable id
  @observable dataSource
  @observable height
  @observable width
  @observable displayHeight
  @observable displayWidth
  @observable originalDisplayWidth
  @observable originalDisplayHeight
  @observable frameWidth
  @observable frameHeight
  @observable yPos
  @observable xPos
  @observable xCrop
  @observable yCrop
  @observable scale
  @observable rotation
  @observable groupId
  @observable photoType
  @observable selected
  @observable frames
  @observable locked
  @observable alignMap
  @observable isUpload
  @observable filters
  @observable assetId


  constructor(
      id, 
      dataSource, 
      height, 
      width, 
      displayHeight, 
      displayWidth, 
      yPos, 
      xPos, 
      scale,
      xCrop,
      yCrop,
      frameWidth,
      frameHeight,
      rotation,
      originalDisplayHeight,
      originalDisplayWidth,
      groupId,
      photoType,
      frames,
      filters,
      isUpload,
      assetId,
      locked,
      alignMap,
      selected
    ){
    makeAutoObservable(this);
    this.type = 'photo'
    this.id = id
    this.dataSource = dataSource
    this.height = height
    this.width = width
    this.displayHeight = displayHeight
    this.displayWidth = displayWidth
    this.yPos = yPos
    this.xPos = xPos
    this.scale = scale
    this.xCrop = xCrop
    this.yCrop = yCrop
    this.frameWidth = frameWidth
    this.frameHeight = frameHeight
    this.originalDisplayHeight = originalDisplayHeight
    this.originalDisplayWidth = originalDisplayWidth
    this.rotation = rotation
    this.groupId = groupId
    this.alignMap = alignMap
    this.photoType = photoType
    this.frames = frames
    this.filters = filters
    this.isUpload = isUpload
    this.assetId = assetId
    this.locked = locked
    this.selected = selected
  }
}

class SVGGroup {
  @observable id
  @observable dataSource
  @observable displayHeight
  @observable displayWidth
  @observable frameHeight
  @observable frameWidth
  @observable xPos
  @observable yPos
  @observable layers
  @observable rotation
  @observable selected
  @observable locked
  @observable xCrop
  @observable yCrop
  @observable boxX
  @observable assetColors
  @observable boxY
  @observable boxWidth
  @observable boxHeight
  @observable finalGroup
  constructor(
    id,
    dataSource,
    displayHeight,
    displayWidth,
    frameHeight,
    frameWidth,
    boxHeight,
    boxWidth,
    boxX,
    boxY,
    xPos,
    yPos,
    xCrop,
    yCrop,
    assetColors,
    layers,
    locked,
    rotation,
    finalGroup,
    selected
  ){
    makeAutoObservable(this)
    this.type = 'svgGroup'
    this.id = id
    this.dataSource = dataSource
    this.displayHeight = displayHeight
    this.displayWidth = displayWidth
    this.frameHeight = frameHeight
    this.frameWidth = frameWidth
    this.boxHeight = boxHeight
    this.boxWidth = boxWidth
    this.boxX = boxX
    this.boxY = boxY
    this.yPos = yPos
    this.xPos = xPos
    this.xCrop = xCrop
    this.yCrop = yCrop
    this.assetColors = assetColors
    this.layers = layers
    this.locked = locked
    this.rotation = rotation
    this.finalGroup = finalGroup
    this.selected = selected
  }

}

class SVGElement {
  @observable id
  @observable dataSource
  @observable height
  @observable width
  @observable displayHeight
  @observable displayWidth
  @observable frameHeight
  @observable frameWidth
  @observable yPos 
  @observable xPos 
  @observable xCrop
  @observable boxWidth
  @observable boxHeight
  @observable fillHex
  @observable yCrop
  @observable locked
  @observable rotation
  @observable selected
  @observable alignMap
  @observable isUpload
  @observable groupId
  @observable boxX
  @observable boxY
  constructor(
    id,
    dataSource,
    height,
    width,
    displayHeight,
    displayWidth,
    frameHeight,
    frameWidth,
    boxHeight,
    boxWidth,
    boxX,
    boxY,
    yPos,
    xPos,
    xCrop,
    yCrop,
    fillHex,
    groupId,
    isUpload,
    rotation,
    locked,
    alignMap,
    selected
  ){
    makeAutoObservable(this)
    this.type = 'svg'
    this.id = id
    this.dataSource = dataSource
    this.height = height
    this.width = width
    this.boxHeight = boxHeight
    this.boxWidth = boxWidth
    this.boxX = boxX
    this.boxY = boxY
    this.displayHeight = displayHeight
    this.displayWidth = displayWidth
    this.isUpload = isUpload
    this.locked = locked
    this.frameHeight = frameHeight
    this.frameWidth = frameWidth
    this.yPos = yPos
    this.xPos = xPos
    this.fillHex = fillHex
    this.xCrop = xCrop
    this.yCrop = yCrop
    this.rotation = rotation
    this.groupId = groupId
    this.alignMap = alignMap
    this.selected = selected
  }
}

class Element {
  @observable id
  @observable dataSource
  @observable height
  @observable width
  @observable displayHeight
  @observable displayWidth
  @observable frameHeight
  @observable frameWidth
  @observable yPos
  @observable xPos
  @observable xCrop
  @observable yCrop
  @observable opacity
  @observable scale
  @observable fillHex
  @observable rotation
  @observable groupId
  @observable locked
  @observable selected
  @observable originX
  @observable originY
  @observable alignMap
  @observable name
  @observable stretchScale
  
  constructor(
    id, 
    dataSource, 
    height, 
    width, 
    displayHeight, 
    displayWidth,
    frameHeight,
    frameWidth,
    yPos, 
    xPos, 
    xCrop,
    yCrop,
    opacity, 
    scale, 
    fillHex, 
    rotation,
    groupId,
    alignMap, 
    name,
    stretchScale,
    originX,
    originY,
    locked,
    selected
    ){
    makeAutoObservable(this);
    this.type = 'element'
    this.id = id
    this.dataSource = dataSource
    this.height = height
    this.width = width
    this.displayHeight = displayHeight
    this.displayWidth = displayWidth
    this.frameHeight = frameHeight
    this.frameWidth = frameWidth
    this.yPos = yPos
    this.xPos = xPos
    this.xCrop = xCrop
    this.yCrop = yCrop
    this.opacity = opacity
    this.scale = scale
    this.fillHex = fillHex
    this.rotation = rotation
    this.groupId = groupId
    this.alignMap = alignMap
    this.originX = originX
    this.originY = originY
    this.selected = selected
    this.locked = locked
    this.name = name
    this.stretchScale = stretchScale
  }
}

class Page {
  @observable height
  @observable width
  @observable backgroundWidth
  @observable backgroundHeight
  @observable displayHeight
  @observable displayWidth
  @observable background
  @observable backgroundUrl
  //Array of objects that include a react component and layer content object
  @observable layers
  @observable active
  @observable title
  @observable transparent
  @observable backgroundId
  @observable id
  @observable toolsOpen
  @observable cropperOpen
  @observable backgroundPosition
  @observable filters


  constructor(
      height, width, 
      displayHeight, displayWidth, 
      background, layers, 
      id, active, 
      title, transparent, 
      backgroundUrl = '', backgroundId, 
      toolsOpen, backgroundWidth, 
      backgroundHeight, cropperOpen, 
      backgroundPosition, filters
    ){
    makeAutoObservable(this);
    this.height = height
    this.width = width
    this.displayHeight = displayHeight
    this.displayWidth = displayWidth
    this.background = background
    this.layers = layers
    this.backgroundUrl = backgroundUrl
    this.id = id
    this.title = title
    this.transparent = transparent
    this.active = active
    this.backgroundHeight = backgroundHeight
    this.backgroundWidth = backgroundWidth
    this.toolsOpen = toolsOpen
    this.backgroundId = backgroundId
    this.cropperOpen = cropperOpen
    this.backgroundPosition = backgroundPosition
    this.filters = filters
  }

}

export {
  TextElement,
  TemplateItem,
  Element,
  PhotoElement,
  TextStyleToolbar,
  ContextMenu,
  LayerGroup,
  SVGElement,
  SVGGroup,
  SelectBox,
  Page
}